import { SOLUTIONS_EN } from "./solutions.en";

export const getSolutions = (lang) => (lang === "en" ? SOLUTIONS_EN : SOLUTIONS);

export const SOLUTIONS = [
  {
    id: "coordinacion-segura",
    num: "01",
    title: "Coordinación segura para equipos y proyectos sensibles",
    reto:
      "Equipos distribuidos que manejan información sensible a través de canales dispersos, sin gobierno de identidad, sin control de dispositivos y sin capacidad de revocación cuando cambia el riesgo.",
    enfoque:
      "Canal corporativo privado con identidad gobernada, altas y bajas controladas, vigencia y revocación centralizadas, minimización de metadatos y despliegues dedicados cuando el riesgo lo requiera.",
    capacidades: ["ONIX Messenger", "Gobierno de dispositivos", "Despliegues dedicados"],
    controles: "Vigencia, suspensión y revocación de identidades; auditoría de altas; clasificación de conversaciones y archivos.",
    limites:
      "El cifrado no protege un terminal comprometido ni una captura realizada por un participante. Las propiedades criptográficas deben verificarse por versión.",
    tools: ["onix-messenger"],
  },
  {
    id: "operaciones-seguridad",
    num: "02",
    title: "Operaciones de seguridad, triage y respuesta",
    reto:
      "Volumen creciente de señales sin priorizar, respuesta descoordinada y falta de trazabilidad sobre quién decidió qué, cuándo y con qué información.",
    enfoque:
      "Centralización de telemetría, correlación de señales, priorización de riesgo y coordinación de una respuesta auditable mediante casos, playbooks y reporting ejecutivo.",
    capacidades: ["ONIX AutoSOC / SIEM", "Sensorización y ciberdefensa ONIX"],
    controles: "Triage documentado, automatización asistida bajo supervisión humana y auditoría completa de decisiones.",
    limites:
      "Cobertura, rendimiento y retención dependen del alcance, las fuentes conectadas, las licencias aplicables y las pruebas de aceptación.",
    tools: ["onix-autosoc-siem", "sensorizacion-ciberdefensa"],
  },
  {
    id: "investigacion-incidentes",
    num: "03",
    title: "Investigación de incidentes, amenazas y relaciones",
    reto:
      "Incidentes y amenazas cuya comprensión exige conectar entidades, indicadores, ubicaciones y cronologías dispersas en múltiples fuentes, conservando la procedencia de cada dato.",
    enfoque:
      "Correlación relacional y geoespacial mediante grafos y mapas operativos, análisis estático controlado de artefactos y conversión de corpus autorizados en indicadores accionables.",
    capacidades: ["ONIX Tactical Graph", "ONIX Malware Static Analyzer", "DWI ONIX"],
    controles: "Niveles de confianza por dato, procedencia y base legítima, validación humana y exportaciones controladas.",
    limites:
      "Una relación gráfica no demuestra causalidad ni identidad. El análisis estático no confirma por sí solo el comportamiento en ejecución.",
    tools: ["onix-tactical-graph", "onix-malware-static-analyzer", "dwi-onix"],
  },
  {
    id: "analitica-video-evidencia",
    num: "04",
    title: "Analítica de vídeo y gestión de evidencia",
    reto:
      "Cámaras y sesiones que generan horas de material sin estructura, con evidencia difícil de localizar, preservar y presentar con garantías de integridad.",
    enfoque:
      "Transformar cámaras y sesiones autorizadas en eventos explicables e investigaciones trazables, con integridad, retención definida y cadena de custodia sobre la evidencia.",
    capacidades: ["ONIX Vision", "Evidence Vault", "Reglas, zonas y umbrales"],
    controles: "Hash e integridad de evidencia, retención por alcance, acceso segregado y exportación controlada.",
    limites:
      "La detección automatizada genera indicadores y prioridades, no conclusiones jurídicas. Precisión y adecuación deben validarse en cada escenario.",
    tools: ["onix-vision"],
  },
  {
    id: "monitorizacion-exposicion",
    num: "05",
    title: "Monitorización de exposición y fuentes autorizadas",
    reto:
      "Superficie externa, credenciales, dominios y menciones que evolucionan sin que la organización disponga de visibilidad continua ni criterios de priorización.",
    enfoque:
      "Inventario de superficie externa, telemetría continuada y monitorización de corpus autorizados con trackers, reglas y validación analítica humana antes de cada alerta.",
    capacidades: ["DWI ONIX", "Sensorización y ciberdefensa ONIX", "Trackers y typosquatting"],
    controles: "Finalidad y autorización previas a cada búsqueda, fuentes permitidas y evidencia con fecha, hash y confianza.",
    limites:
      "La búsqueda se realiza sobre el corpus recopilado, importado o conectado. No existe acceso universal a toda la dark web ni atribución infalible.",
    tools: ["dwi-onix", "sensorizacion-ciberdefensa"],
  },
  {
    id: "arquitecturas-dedicadas",
    num: "06",
    title: "Arquitecturas dedicadas e integraciones controladas",
    reto:
      "Organizaciones que no pueden operar sobre infraestructuras compartidas ni aceptar integraciones que transfieran datos sin clasificación, finalidad ni control de acceso.",
    enfoque:
      "Diseño de despliegues dedicados e interfaces gobernadas entre capacidades ONIX y sistemas del cliente: cada flujo responde a una finalidad, una clasificación y un control de acceso.",
    capacidades: ["Despliegues dedicados", "Interfaces gobernadas", "Integración con casos y SIEM"],
    controles: "Segregación de entornos, mínimo privilegio, control de versiones y trazabilidad de cada flujo de datos.",
    limites:
      "Las propiedades finales dependen del alcance, la versión desplegada, las integraciones y las pruebas de aceptación acordadas.",
    tools: ["onix-messenger", "onix-autosoc-siem"],
  },
];
